'use strict';

var EditGlobalDns = require('actionGroups/globalDns/GlobalDns');

module.exports = {
  Model: EditGlobalDns,
};
